import { immerable } from 'immer';
import type { ChannelDTO } from '../dto/channel.dto.js';
import { Tier } from './tier.model.js';

export class Channel implements ChannelDTO {
  [immerable] = true;

  _id: string;
  copyright?: string | undefined;
  description: string;
  image100: string;
  image30: string;
  image600: string;
  image60: string;
  language?: string | undefined;
  lastBuildDate?: Date | undefined;
  link?: string | undefined;
  pubDate?: Date | undefined;
  slug: string;
  tiers: Tier[];
  title: string;

  constructor(channel: ChannelDTO) {
    this._id = channel._id.toString();
    this.description = channel.description;
    this.image100 = channel.image100;
    this.image30 = channel.image30;
    this.image60 = channel.image60;
    this.image600 = channel.image600;
    this.language = channel.language;
    this.lastBuildDate = channel.lastBuildDate;
    this.link = channel.link;
    this.pubDate = channel.pubDate;
    this.slug = channel.slug;
    this.tiers = channel.tiers.map(tier => new Tier(tier));
    this.title = channel.title;
  }

  get hasTiers() {
    return this.tiers.length > 0;
  }

  getTier(id: string) {
    return this.tiers.find(tier => tier._id === id);
  }
}
